export enum SOCIAL_LOGIN_MODE {
  GOOGLE = 'GOOGLE',
}
